import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.29183 13.125L2.29183 6.875C2.29183 6.1849 2.85172 5.625 3.54183 5.625L16.4585 5.625C17.1486 5.625 17.7085 6.1849 17.7085 6.875L17.7085 13.125C17.7085 13.8151 17.1486 14.375 16.4585 14.375L3.54183 14.375C2.85172 14.375 2.29183 13.8151 2.29183 13.125Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.79199 11.0416L4.79199 8.95825"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2085 10.625C14.8634 10.625 14.5835 10.3451 14.5835 10C14.5835 9.65495 14.8634 9.375 15.2085 9.375C15.5535 9.375 15.8335 9.65495 15.8335 10C15.8335 10.3451 15.5535 10.625 15.2085 10.625Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};
